import { useState } from 'react';
import { useAuth, useLocale } from '../../context';
import { api } from '../../api';
import '../../styles/registration.css';

function PasswordField({ label, value, onChange, autoComplete }) {
  return (
    <div className="container--CCNx7 container_medium label--SNSj8">
      <div className="container__label">{label}</div>
      <div className="inputContainer inputContainer_large">
        <div className="inputLine inputLine_leftOffset inputLine_rightOffset inputLine_withoutBottomOffset">
          <div className="inputLine__content">
            <input
              type="password"
              className="input"
              value={value}
              onChange={onChange}
              autoComplete={autoComplete}
              maxLength={1000}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default function MobileAccountChangePassword({ onDone }) {
  const { token } = useAuth();
  const _locale = useLocale();
  const tr = _locale.t;
  const [step, setStep] = useState('current');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const handleNext = (event) => {
    event.preventDefault();
    setErr('');
    if (step === 'current') {
      if (!currentPassword) {
        setErr(tr('auth.validation.passwordRequired'));
        return;
      }
      setStep('new');
      return;
    }
    if (step === 'new') {
      if (!newPassword) {
        setErr(tr('auth.validation.passwordRequired'));
        return;
      }
      if (newPassword.length < 6) {
        setErr(tr('auth.validation.passwordShort'));
        return;
      }
      if (newPassword === currentPassword) {
        setErr(tr('account.profile.passwordSame'));
        return;
      }
      setStep('confirm');
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErr('');
    if (newPassword !== confirmPassword) {
      setErr(tr('account.profile.passwordMismatch'));
      return;
    }
    if (newPassword === currentPassword) {
      setErr(tr('account.profile.passwordSame'));
      return;
    }
    setLoading(true);
    try {
      await api.changePassword(token, { currentPassword, newPassword });
      onDone?.();
    } catch (error) {
      const message = error.message || '';
      setErr(message);
      if (/mevcut|current|hatalı|incorrect|wrong/i.test(message)) {
        setStep('current');
        setNewPassword('');
        setConfirmPassword('');
      }
    } finally {
      setLoading(false);
    }
  };

  const isLastStep = step === 'confirm';

  return (
    <div className="mobile-account-password registration--mobile-auth">
      <form
        className="mobile-account-password__form"
        onSubmit={isLastStep ? handleSubmit : handleNext}
        noValidate
      >
        {step === 'current' && (
          <PasswordField
            label={tr('account.security.enterCurrent')}
            value={currentPassword}
            onChange={(event) => setCurrentPassword(event.target.value)}
            autoComplete="current-password"
          />
        )}
        {step === 'new' && (
          <PasswordField
            label={tr('account.security.new')}
            value={newPassword}
            onChange={(event) => setNewPassword(event.target.value)}
            autoComplete="new-password"
          />
        )}
        {step === 'confirm' && (
          <PasswordField
            label={tr('account.profile.passwordConfirm')}
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
            autoComplete="new-password"
          />
        )}
        {err ? <div className="mobile-account-password__error">{err}</div> : null}
        <div className="form-bottom-buttons--e4qpk">
          <button
            type="submit"
            className="button _accent _sizeL _hasText _interactive"
            disabled={loading}
          >
            {loading ? '...' : isLastStep ? tr('account.profile.send') : tr('account.profile.next')}
          </button>
        </div>
      </form>
    </div>
  );
}
